import { api } from '../../../shared/services/api';

/**
 * Service for managing email accounts
 */
export const emailAccountsService = {
    /**
     * Get all email accounts
     */
    async getAll() {
        const response = await api.get('/api/email-accounts');
        return response;
    },

    /**
     * Create a new email account
     */
    async create(email, name) {
        const response = await api.post('/api/email-accounts', {
            email,
            name
        });
        return response;
    },

    /**
     * Delete an email account
     */
    async delete(id) {
        const response = await api.delete(`/api/email-accounts/${id}`);
        return response;
    }
};
